<template>
  <BbCropper :parent="context"
             :ident="config.ident"
             :CustomImageConfig="customImageConfig"
             :key-string="config.prop">
  </BbCropper>
</template>

<script>
import { PIC_API as picAPI } from "@/utils/common";
import genApi, { get } from "@/quick/gen-api";
import BbCropper from "@/quick/N_Cropper";

export default {
  name: "ECropper",
  cName:'cropper',
  defaultValue:'[]',
  components: { BbCropper },
  // Props 是可选的
  props: ["config", "context"],
  data() {
    return {};
  },
  computed:{
    customImageConfig(){
      let v = undefined
      try{
        if(this.config.customImageConfig.trim()!=''){
          v=this.looseJsonParse(this.config.customImageConfig)
        }
      }catch(e){
        console.warn('错误的配置')
      }
      return v
    }
  },
  methods: {
    looseJsonParse(obj) {
      return Function('"use strict";return (' + obj + ")")();
    },
  }
};
</script>
